import { lessonTopicPhrase } from './lessonAiContentBlocks';
import {
  miniReadingParagraph,
  vocabularyItemsForTopic,
  dialogueScriptForTopic,
} from './lessonMaterialSnippets';

/** Escape text for safe HTML seed content in TipTap */
export function escapeHtml(text) {
  if (text == null) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Fallback HTML when the API did not return `htmlContent`: real student text + lexis + tasks
 * (not methodology for teachers).
 * @param {{ title?: string, objective?: string, estimatedMinutes?: number, suggestedExerciseTypes?: string[] }} section
 * @param {string} [lessonTitle]
 */
export function sectionToSeedHtml(section, lessonTitle = '') {
  const topic = lessonTopicPhrase(lessonTitle, section);
  const safeTopic = escapeHtml(topic);
  const title = escapeHtml(section.title || 'Section');
  const st = String(section.title || '').toLowerCase();
  const mins = Number(section.estimatedMinutes) || 0;

  let html = `<h2>${title}</h2>`;
  html += `<p><strong>Topic:</strong> «${safeTopic}»</p>`;

  html += `<h3>Text</h3>`;
  html += `<p>${escapeHtml(miniReadingParagraph(topic, section))}</p>`;

  if (st.includes('listen')) {
    html += `<h3>Dialogue</h3>`;
    html += dialogueScriptForTopic(topic);
  }

  const vocabCount = st.includes('vocab') || st.includes('lexis') || st.includes('words') ? 8 : 6;
  html += `<h3>Vocabulary</h3><ul>`;
  vocabularyItemsForTopic(topic, vocabCount).forEach(({ word, definition }) => {
    html += `<li><strong>${escapeHtml(word)}</strong> — ${escapeHtml(definition)}</li>`;
  });
  html += `</ul>`;

  html += `<h3>Tasks</h3><ol>`;
  html += `<li>Underline the sentence that best summarises the main idea about «${safeTopic}».</li>`;
  html += `<li>Write a short paragraph (40–60 words) using at least three words from the list.</li>`;
  if (st.includes('speak') || st.includes('discussion')) {
    html += `<li>Prepare a one-minute spoken answer: What should change in the next five years regarding «${safeTopic}»?</li>`;
  }
  if (st.includes('writ') || st.includes('homework')) {
    html += `<li><strong>Writing:</strong> Write 120–150 words: describe one problem and one possible solution related to «${safeTopic}». Use linking words (however, therefore, because).</li>`;
  }
  if (mins) {
    html += `<li><em>Suggested time for this block: ~${mins} minutes.</em></li>`;
  }
  html += `</ol>`;
  html += `<p><em>Interactive exercises (gap-fill, true/false, etc.) are inserted below.</em></p>`;
  return html;
}

/**
 * HTML для редактора: полный контент от AI (`htmlContent`) или ученический seed.
 * @param {{ htmlContent?: string, title?: string, objective?: string, estimatedMinutes?: number, suggestedExerciseTypes?: string[] }} section
 * @param {string} [lessonTitle]
 */
export function sectionToEditorHtml(section, lessonTitle = '') {
  if (section && typeof section.htmlContent === 'string' && section.htmlContent.trim()) {
    return section.htmlContent.trim();
  }
  return sectionToSeedHtml(section, lessonTitle);
}
